// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".excelImport[data-v-7f3776bf] {\n  /* width: 1035px !important; */\n  width: 100%;\n}\n.excelImport[data-v-7f3776bf]  .el-upload {\n  width: 100%;\n}\n.excelImport[data-v-7f3776bf]  .el-upload .el-upload-dragger {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
